module.exports = __webpack_public_path__ + "img/vulcans-ff-2.c106629.jpg";